/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

export default class Queue<T = any> {
    array: Array<T>
    size: number

    constructor() {
        this.array = [];
        this.size = 0;
    }

    getSize(): number {
        return this.size;
    }

    add(obj: T): void {
        this.array.unshift(obj);
        this.size++;
    }

    remove(): T | undefined {
        if (this.size === 0) return undefined;

        this.size--;
        return this.array.pop();
    }

    onTop(): T | undefined {
        if (this.size === 0) return undefined;

        return this.array[this.array.length - 1];
    }
}
